module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/VscDfV/tc-custom/9780544177642.jpg?1736886759723",
      "alt": "This image is the cover for the book Easy Slow Cooker Recipes, Betty Crocker Cooking"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Easy Slow Cooker Recipes, Betty Crocker Cooking\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Simple, scrumptious slow cooker meals are a cinch with this cookbook from Betty Crocker.")])]), _c('p', [_vm._v("A slow cooker makes it easy to get family meals on the table fast—just get everything started before you leave for the day, then come home to a fully cooked dinner! Inside, you'll find a quick guide to understanding your slow cooker, plus over 20 proven slow cooker recipes for comforting soups, stews and main dishes, including zesty international options and healthy vegetarian choices.")]), _c('p', [_vm._v("For more great ideas visit bettycrocker.com")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Betty Crocker\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0